const LOCALE_PREFIX_LENGTH: number = 2;

/**
 * Takes the first two characters of the locale so it matches with Google API's locale
 */
export function getLocaleSettings(locale: string): string {
  if (!locale) {
    return '';
  }
  if (locale === 'en_GB') {
    return 'en-gb';
  }

  return locale.substring(0, LOCALE_PREFIX_LENGTH);
}
